import 'selectize';
import { Url, Ajax } from 'rustig';

export class TagSearch {
  public static get wireup(): string { return '[data-tag-search]'; }

  private element: HTMLSelectElement;

  public constructor(element: HTMLSelectElement, options: any) {
    if (!element)
      throw new Error('You must provide an element to TagSearch');
    this.element = element;

    $(this.element).selectize(this.getDefaultOptions());
  }

  private getDefaultOptions(): any {
    let searchUrl = this.element.getAttribute('data-search-url');
    let clearOptions = () => this.element.selectize.clearOptions();
    let closeAndClearOptions = () => {
      this.element.selectize.close();
      clearOptions();
    }

    return {
      maxItems: null,
      highlight: false,
      loadThrottle: 500,
      load: function (query, callback) {
        if (!query.length)
          return callback();

        let onError = () => callback();
        Ajax.execute({
          url: new Url(searchUrl).setQueryParameter('searchText', query).toUrl(),
          type: 'GET',
          error: onError,
          success: function (res) {
            if (res.isError)
              onError();
            else {
              clearOptions();
              callback(res);
            }
          }
        });
      },
      onType: function (str) {
        if (!str)
          clearOptions();
      },
      onDropdownClose: clearOptions,
      onItemRemove: closeAndClearOptions,
      onItemAdd: closeAndClearOptions,
      render: {
        item: function (item, escape) {
          return '<div class="item" data-value="' + item.value + '">' + escape(item.text) + '</div>';
        },
        option: function (item, escape) {
          return '<div class="item" data-value="' + item.value + '">' + escape(item.text) + '</div>';
        }
      },
      create: function (input) {
        return { value: input, text: input };
      }
    }
  }

  public static load(element: HTMLElement, options?: any): TagSearch {
    let tagSearchElement = element as ITagSearchElement;
    if (!tagSearchElement.tagSearch)
      tagSearchElement.tagSearch = new TagSearch(tagSearchElement, options);

    return tagSearchElement.tagSearch;
  }
}

export interface ITagSearchElement extends HTMLSelectElement {
  tagSearch: TagSearch;
}

export default TagSearch;